import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { concatMap, map, shareReplay, startWith, timeout } from 'rxjs/operators';
import { combineLatest, from, Observable } from 'rxjs';
import { ClassroomService } from 'src/app/_services/classroom.service';
import { MatDialog } from '@angular/material/dialog';
import { UnidadFormEnlazarClassroomComponent } from '../unidad-form-enlazar-classroom/unidad-form-enlazar-classroom.component';
import { CustomAlertService } from 'src/app/_components/custom-alert/custom-alert.service';
import { ThrobberService } from 'src/app/_services/throbber.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GoogleClass } from 'src/app/_models/googleClassroom/google-class';
import { Unidad } from 'src/app/_models/unidad';

@Component({
  selector: 'app-unidad-form-classroom',
  standalone: false,
  templateUrl: './unidad-form-classroom.component.html',
  styleUrls: ['./unidad-form-classroom.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnidadFormClassroomComponent implements OnInit {

  @Input()
  unidad: Unidad;
  @Input()
  unidadForm: UntypedFormGroup;
  @Input()
  materias: any[];

  mcps$: Observable<any>;

  courses$: Observable<GoogleClass[]>;

  checkForm = new UntypedFormGroup({});

  mcps: any[];

  constructor(
    private classroomService: ClassroomService,
    private matDialog: MatDialog,
    private customAlertService: CustomAlertService,
    private throbberService: ThrobberService,
    private snackBar: MatSnackBar
    ) { }

  ngOnInit(): void {
    const mcpsPre$ = this.unidadForm.get('materiasPeriodo').valueChanges.pipe(
      startWith(this.unidadForm.get('materiasPeriodo').value),
      map(data => {
        const value = this.checkForm.value;
        this.checkForm = new UntypedFormGroup({});
        const materiasRes = this.materias.filter(item => data.findIndex(materiaId => materiaId === item.id) > -1);
        materiasRes.forEach(item => {
          const id = item.id;
          this.checkForm.addControl(id, new UntypedFormControl(false));
          if (value[id]) {
            this.checkForm.get(id).setValue(value[id]);
          }
        });
        return materiasRes;
      }),
      shareReplay(1)
    );

    const mcpsConCourses$ = mcpsPre$.pipe(
      concatMap(data => {
        return this.classroomService.getListaAsociacionMcp(data.map(item => item.id).join(',')).pipe(
          map(asociacion => {
            data.forEach(element => {
              const mpcEditar = asociacion.find(item => item.materiaCursoPeriodoId === element.id);
              if (mpcEditar) {
                element.course = mpcEditar.course;
                element.classroomCourseId = mpcEditar.classroomCourseId;
              } else {
                element.classroomCourseId = 0;
                element.course = 0;
              }
            });
            return data;
          })
        );
      })
    );

    this.mcps$ = combineLatest(([mcpsConCourses$, this.classroomService.cambios$])).pipe(
      map(([mcps, cambios]) => {
        if (cambios && cambios.accion === 'materia-update') {
          cambios.obj.forEach(item => {
            const index = mcps.findIndex(materia => +materia.id === +item.materiaCursoPeriodoId);
            if (index > -1) {
              mcps[index].classroomCourseId = +item.classroomCourseId || 0;
              mcps[index].course = item.course;
            }
          });
        }
        this.mcps = mcps;
        return mcps;
      }),
      shareReplay(1)
    );

    this.courses$ = this.classroomService.getClassroomClasses().pipe(shareReplay(1));
  }

  enlazar(materia: string | any, accion: boolean) {
    const materias = materia === 'seleccionadas' ? this.listaMaterias() : [materia];
    if (accion) {
      this.throbberService.setThrobberState(true);
      this.courses$.subscribe(res => {
        this.throbberService.setThrobberState(false);
        this.matDialog.open(UnidadFormEnlazarClassroomComponent, {
          width: '100%',
          height: '100%',
          maxWidth: '100vw !important',
          maxHeight: 'calc(-64px + 100vh)',
          position: { bottom: '0'},
          disableClose: true,
          data: {
            materias,
            accion,
            classrooms: res
          }
        });
      },
      err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    } else {
      this.classroomService.enlazarClassroomMcp(materias, accion).subscribe(res => {
        this.throbberService.setThrobberState(false);
        this.snackBar.open('Se ha desenlazado la materia del Google Course.');
      },
      err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible realizar la acción. <br> Código de error: ${err.statusText}`
        });
      });
    }
  }

  selectAll(value: boolean) {
    this.mcps.forEach(materia => {
      this.checkForm.get('' + materia.id).setValue(value);
    });
  }

  listaMaterias(): any[] {
    const resp = [];
    const value = this.checkForm.value;
    for (const property in value) {
      if (value.hasOwnProperty(property)) {
        if (value[property]) {
          resp.push(+property);
        }
      }
    }
    return resp.map(item => this.materias.find(materia => materia.id === item));
  }
}
